import { render } from "./EditDepartureSideNav.vue?vue&type=template&id=1cd06c8a"
import script from "./EditDepartureSideNav.vue?vue&type=script&lang=js"
export * from "./EditDepartureSideNav.vue?vue&type=script&lang=js"

import exportComponent from "D:\\VueLearning\\SheepbaseVueJs\\SheepBaseVueApp\\node_modules\\vue-loader\\dist\\exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__